// Small pill showing the number of unrated roasts.
//
// Sits next to the "Roasts" nav link so the operator always sees "you have 3
// roasts waiting for a rating" without having to click into a list. Clicking
// the pill deep-links into RoastList with the unrated-only filter already on.
//
// We avoid a global store for this — a single fetch on mount is cheap, and
// the pill auto-refetches when the user navigates (keyed on pathname).

import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useApi } from "../useApi";

export function UnratedPill() {
  const api = useApi();
  const location = useLocation();
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .listUnratedRoasts()
      .then((r) => {
        if (!cancelled) setCount(r.roasts?.length ?? 0);
      })
      .catch(() => {
        // Silent failure — the pill is an accent, not a gate. A failed
        // /api call will still surface elsewhere if it matters.
        if (!cancelled) setCount(null);
      });
    return () => {
      cancelled = true;
    };
    // Refetch whenever the URL changes — this is the cheapest way to keep
    // the count fresh after the user rates something.
  }, [api, location.pathname]);

  if (count == null || count === 0) return null;

  return (
    <Link
      to="/?only_unrated=1"
      className="badge warn"
      style={{ textDecoration: "none" }}
      aria-label={`${count} unrated roast${count === 1 ? "" : "s"}`}
      title="Show unrated roasts"
    >
      {count} unrated
    </Link>
  );
}
